var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Flexbox 也可以制作结尾参差不齐的垂直列")]),_c('p',[_vm._v("但它并不那么聪明，因为您需要设置某种高度才能使其包裹列。您还必须明确宽度，而不是让它为您决定列。")]),_c('p',[_vm._v("但这是可行的，如果有空间，它会自动调整间隙。")]),_c('div',{staticClass:"masonry"},_vm._l((30),function(item){return _c('div',{key:item,attrs:{"id":item}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }